__turbopack_context__.v({
  "blueLink": "commone-module__8f9anq__blueLink",
  "brawnLink": "commone-module__8f9anq__brawnLink",
  "redLink": "commone-module__8f9anq__redLink",
  "softLink": "commone-module__8f9anq__softLink",
  "violetLink": "commone-module__8f9anq__violetLink",
  "wikiLink": "commone-module__8f9anq__wikiLink",
  "yellowLink": "commone-module__8f9anq__yellowLink",
});
